import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold text-dark mb-5 fs-1" }, "What A Pretty Form"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-4 text-muted" }, "This information will help us tailor your experience.")
], -1)
const _hoisted_4 = { class: "mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold fs-3 text-dark mb-5" }, "Select A Category", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "form-options",
  checked: "",
  value: "1",
  id: "kt_form_options_1"
}, null, -1)
const _hoisted_8 = {
  class: "col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-125px",
  for: "kt_form_options_1"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2x svg-icon-gray-800 me-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fw-bold" }, "Movie Creator", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "form-options",
  value: "2",
  id: "kt_form_options_2"
}, null, -1)
const _hoisted_12 = {
  class: "col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-125px",
  for: "kt_form_options_2"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2x svg-icon-gray-800 me-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fw-bold" }, "Networking", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "form-options",
  value: "3",
  id: "kt_form_options_3"
}, null, -1)
const _hoisted_16 = {
  class: "col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-125px",
  for: "kt_form_options_3"
}
const _hoisted_17 = { class: "svg-icon svg-icon-2x svg-icon-gray-800 me-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fw-bold" }, "eCommerce", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "form-options",
  value: "4",
  id: "kt_form_options_4"
}, null, -1)
const _hoisted_20 = {
  class: "col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-125px",
  for: "kt_form_options_4"
}
const _hoisted_21 = { class: "svg-icon svg-icon-2x svg-icon-gray-800 me-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fw-bold" }, "Data Analysis", -1)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><div class=\"d-flex justify-content-between mb-5\"><label class=\"fw-bold fs-3 text-dark\">Select An Option</label><span class=\"fw-bold fs-6 text-muted\">Optional</span></div><select class=\"form-select form-select-lg form-select-solid fw-bold fs-6 text-gray-600 h-65px\" data-control=\"select2\" data-placeholder=\"Choose one\" data-hide-search=\"true\"><option>2</option><option>3</option><option>4</option><option>5</option></select></div><div class=\"mb-10\"><h3 class=\"fw-bold fs-3 text-dark mb-5\">How Big Is Your Fleet?</h3><div class=\"row\" data-buttons=\"radio\"><input type=\"radio\" class=\"btn-check\" name=\"form-fleet\" value=\"1\" id=\"kt_form_fleet_1\"><label class=\"col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-90px\" for=\"kt_form_fleet_1\"><span class=\"text-gray-800 fw-bold\">1-10</span></label><input type=\"radio\" class=\"btn-check\" name=\"form-fleet\" checked value=\"2\" id=\"kt_form_fleet_2\"><label class=\"col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-90px\" for=\"kt_form_fleet_2\"><span class=\"text-gray-800 fw-bold\">10-50</span></label><input type=\"radio\" class=\"btn-check\" name=\"form-fleet\" value=\"3\" id=\"kt_form_fleet_3\"><label class=\"col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-90px\" for=\"kt_form_fleet_3\"><span class=\"text-gray-800 fw-bold\">50-100</span></label><input type=\"radio\" class=\"btn-check\" name=\"form-fleet\" value=\"4\" id=\"kt_form_fleet_4\"><label class=\"col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-90px\" for=\"kt_form_fleet_4\"><span class=\"text-gray-800 fw-bold\">100-500</span></label><input type=\"radio\" class=\"btn-check\" name=\"form-fleet\" value=\"5\" id=\"kt_form_fleet_5\"><label class=\"col btn btn-lg btn-outline btn-outline-dashed btn-outline-default py-5 px-4 m-2 min-w-90px\" for=\"kt_form_fleet_5\"><span class=\"text-gray-800 fw-bold\">500+</span></label></div></div><div class=\"mb-10\"><a href=\"#\" class=\"btn btn-primary px-11 py-4 fw-bolder fs-3\">Create Fleet</a></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("label", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen002.svg" })
            ]),
            _hoisted_10
          ]),
          _hoisted_11,
          _createElementVNode("label", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/electronics/elc007.svg" })
            ]),
            _hoisted_14
          ]),
          _hoisted_15,
          _createElementVNode("label", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm002.svg" })
            ]),
            _hoisted_18
          ]),
          _hoisted_19,
          _createElementVNode("label", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
            ]),
            _hoisted_22
          ])
        ])
      ]),
      _hoisted_23
    ])
  ]))
}